


























































import { Component, Prop, Vue } from 'vue-property-decorator'
import MediaAvatar from '@/components/reusable-components/media/MediaAvatar.vue'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import ModalName from '@/utils/ModalName'
import API from '@/services/API'
import { ButtonTheme } from '@/utils/ButtonAttr'
import ButtonGroup from '@/components/reusable-components/controls/button/ButtonGroup.vue'
import TranslationModule from '@/utils/TranslationModule'

const CROPPER_RESULT_OPTS = {
    type: 'blob',
    size: { width: 400, height: 400 },
    format: 'jpg',
    quality: 1,
    circle: false,
}

@Component({
    components: { ButtonGroup, EvaIcon, BaseButton, MediaAvatar },
})
export default class AuthUpdateAvatar extends Vue {
    @Prop({ type: String, default: '/build/v2/img/member/avatar.jpg' }) picture!: string
    @Prop({ type: String, default: ModalName.UPDATE_ACCOUNT_AVATAR }) modalName!: string

    ButtonTheme: typeof ButtonTheme = ButtonTheme
    TranslationModule: typeof TranslationModule = TranslationModule

    originalB64ImgUploaded: any = null
    loading = false

    $refs!: {
        cropper: any
        input: HTMLInputElement
    }

    onAvatarUploaded(e: Event) {
        const files = (e.target as HTMLInputElement).files

        if (!files || files.length === 0) {
            return null
        }

        const file = files[0]
        const fileReader = new FileReader()

        fileReader.onload = () => {
            this.originalB64ImgUploaded = fileReader.result
            this.$modal.show(ModalName.UPDATE_ACCOUNT_AVATAR)
        }
        fileReader.onerror = e => console.error(e)

        fileReader.readAsDataURL(file)
    }

    onModalOpened() {
        this.$refs.cropper.bind({ url: this.originalB64ImgUploaded })
    }

    onModalClosed() {
        this.$refs.input.value = ''
    }

    onSaveAvatar() {
        if (!this.loading) {
            this.loading = true
            const fileReader = new FileReader()
            this.$refs.cropper.result(CROPPER_RESULT_OPTS, (blobImg: any) => {
                fileReader.addEventListener('load', async () => {
                    const b64AvatarWithMetadata: any = fileReader.result
                    const b64Avatar = b64AvatarWithMetadata.split(',')[1]

                    try {
                        await API.patchMeAvatar(b64Avatar)
                        await this.$store.dispatch('user/setMe', null)
                        await this.$store.dispatch('user/getMe')
                        this.$modal.hide(ModalName.UPDATE_ACCOUNT_AVATAR)
                    } catch (e) {
                        console.error(e)
                        this.$notify({
                            title: 'error',
                            text: 'An error occurred',
                            type: 'error',
                        })
                    } finally {
                        this.loading = false
                    }
                })

                fileReader.readAsDataURL(blobImg)
            })
        }
    }
}
